/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, number, bool, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedDate from "pages/_components/FormattedDate";
import { TransactionSign } from "pages/_components/TransactionCard";
import Button from "pages/_components/Button";

const SolicitAvalSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const {
        numeroEcheq = props.numeroEcheq,
        montoTotal = props.montoTotal,
        curency = props.curency,
        idEcheq = props.idEcheq,
        document = props.document,
        avalista = props.avalista,
        domicilio = props.domicilio,
        caracterAval = props.caracterAval,
        fechaEmision = props.fechaEmision,
        fechaPago = props.fechaPago,
        concepto = props.concepto,
        motivoAnulacion = props.motivoAnulacion,
        action = props.action,
        ticket = props.ticket,
        showMoreData = props.showMoreData,
        setShowMoreData = props.setShowMoreData,
        isDesktop = props.isDesktop,
    } = data;
    let title;
    let reason = "echecks.echeckReason";

    if (action === "AVAL-ANULATE") {
        title = "echeck.anulate.label";
        reason = "echeck.anulate.label";
    }
    if (action === "AVAL-REPUDIATE") {
        title = "echeck.repudiate.label";
    }
    if (action === "AVAL-ADMIT") {
        title = "echecks.echeckReason";
    }

    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    if (ticket) {
        return (
            <div className="ticket__body echeq-aval">
                <div className="ticket-header-info">
                    <CustomData titleText="echecks.numero.echeq" titleTextType="I18N" valueText={numeroEcheq} />
                    <CustomData
                        dataClass="amount tag tag-warning"
                        titleText="echecks.monto.total"
                        titleTextType="I18N"
                        valueText={<FormattedAmount className="data-label" currency={curency} quantity={montoTotal} />}
                    />
                </div>

                <div className="view-more-data-button no-print" id="element-to-ignore">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                    <CustomData titleText="echecks.id.echeq" titleTextType="I18N" valueText={idEcheq} />
                    <CustomData titleText="echecks.document" titleTextType="I18N" valueText={document} />
                    <CustomData titleText="echecks.avalista" titleTextType="I18N" valueText={avalista} />{" "}
                    <CustomData titleText="echecks.address" titleTextType="I18N" valueText={domicilio} />{" "}
                    <CustomData titleText="echek.aval.caracter" titleTextType="I18N" valueText={caracterAval} />
                    <CustomData
                        titleText="echecks.createdRange.label"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={fechaEmision} />}
                    />
                    <CustomData
                        titleText="echecks.payedRange.label"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={fechaPago} />}
                    />
                    <CustomData
                        titleText="echecks.emit.concept.label"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={`transfer.reasons.${concepto}`}
                    />
                    <CustomData titleText={reason} titleTextType="I18N" valueText={motivoAnulacion} />

                    {transaction.idTransactionStatus === "PENDING" ? (
                        <TransactionSign creationTime isSmall isDesktop={isDesktop} showMoreData={showMoreData} />
                    ) : (
                        <TransactionSign
                            hasVaucher
                            noHorizontalDivider
                            creationTime
                            isSmall
                            isDesktop={isDesktop}
                            showMoreData={showMoreData}
                        />
                    )}
                </div>
            </div>
        );
    }
    return (
        <GridTable className="deposit-summary form-summary">
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData titleText="echecks.numero.echeq" titleTextType="I18N" valueText={numeroEcheq} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.monto.total"
                        titleTextType="I18N"
                        valueText={<FormattedAmount className="data-label" currency={curency} quantity={montoTotal} />}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="echecks.id.echeq" titleTextType="I18N" valueText={idEcheq} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="echecks.document" titleTextType="I18N" valueText={document} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="echecks.avalista" titleTextType="I18N" valueText={avalista} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="echecks.address" titleTextType="I18N" valueText={domicilio} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="echek.aval.caracter" titleTextType="I18N" valueText={caracterAval} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.createdRange.label"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={fechaEmision} />}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.payedRange.label"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={fechaPago} />}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.emit.concept.label"
                        titleTextType="I18N"
                        valueTextType="I18N"
                        valueText={`transfer.reasons.${concepto}`}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText={reason} titleTextType="I18N" valueText={motivoAnulacion} />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

SolicitAvalSummaryBody.propTypes = {
    numeroEcheq: string,
    montoTotal: number,
    curency: string,
    idEcheq: string,
    document: string,
    avalista: string,
    domicilio: string,
    caracterAval: string,
    fechaEmision: string,
    fechaPago: string,
    concepto: string,
    motivoAnulacion: string,
    action: string,
    ticket: bool,
    showMoreData: bool,
    isDesktop: bool,
    setShowMoreData: func,
};

SolicitAvalSummaryBody.defaultProps = {
    numeroEcheq: "",
    montoTotal: null,
    curency: "",
    idEcheq: "",
    document: "",
    avalista: "",
    domicilio: "",
    caracterAval: "",
    fechaEmision: "",
    fechaPago: "",
    concepto: "",
    motivoAnulacion: "",
    action: "",
    ticket: false,
    showMoreData: false,
    isDesktop: false,
    setShowMoreData: () => {},
};

export default SolicitAvalSummaryBody;
